<template>
  <v-content>
    <!-- Mobile backdrop: tap to close sidebar -->
    <div v-if="sidebarOpen" class="sidebar-backdrop" @click="toggleClass" />

    <v-container fluid fill-height grid-list-lg wrap class="py-2 pl-3 pr-0">
      <v-layout :column="$vuetify.breakpoint.xsOnly">
        <!--  
                            database-overview

                            The database overview pane can be hidden by clicking the list icon
                            on the editor tab pane.

                            We also set the height and width based on the breakpoint. This could be
                            done with pure CSS media queries, but vuetify provides us the means to 
                            do it right here with JS.
                        -->

        <!-- Vertical navbar -->
        <!-- Admin Navbar -->
          <div v-if="adminMenuAvailable && !this.$route.name.includes('selfservice')" class="vertical-nav bg-white" id="sidebar">
          <div class="py-2 px-3 bg-light">
            <div class="media d-flex align-items-center justify-content-end">
              <button class="sidebar-close-btn" @click="toggleClass">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
          </div>
          <app-menu />
        </div>

        <!-- Non Admin Self Service Navbar -->
        <div v-else class="vertical-nav bg-white" id="sidebar">
          <div class="ml-4 mr-4 mt-4">
            <v-card class="mb-2">
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <v-img
                    v-if="this.personPic"
                    class="ml-2 mr-n4 rounded mt-2"
                    :src="this.personPic">
                  </v-img>
                  <v-img
                    v-else
                    class="ml-2 mr-n4 rounded mt-2"
                    :src="`${publicPath}images/avatar-1577909_960_720.png`">
                  </v-img>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-row class="mt-3 mb-1 ml-2 mr-2">
                    <p style="font-size: 11px; color: #64748B; line-height: 1.4; margin-bottom: 4px;">{{`${this.$t('selfservicescreen.welcome')}, ${personName}`}}</p>
                    <span v-if="activeProfile" style="display:inline-block;font-size:10px;font-weight:700;color:#4F6BFF;background:#EEF2FF;border-radius:6px;padding:2px 7px;letter-spacing:0.03em;">{{ activeProfile.staffcode }}</span>
                  </v-row>
                  <div style="display:flex;justify-content:flex-end;align-items:center;margin-top:12px;margin-bottom:6px;margin-right:6px;gap:2px;">
                    <v-menu v-if="staffProfiles.length > 1" offset-y bottom left>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" title="Switch Profile" style="color:#4F6BFF;">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="9" cy="7" r="4"/><path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"/>
                            <path d="M19 8l2 2-2 2"/><path d="M21 10H15"/>
                          </svg>
                        </v-btn>
                      </template>
                      <v-list dense style="min-width:180px;">
                        <div style="padding:8px 12px 4px;font-size:10px;font-weight:700;color:#94A3B8;letter-spacing:0.08em;text-transform:uppercase;">Switch Profile</div>
                        <v-divider/>
                        <v-list-item
                          v-for="p in staffProfiles"
                          :key="p.id"
                          @click="switchProfile(p.id)"
                          :style="p.id == activeStaffId ? 'background:#EEF2FF;' : ''"
                          style="min-height:44px;"
                        >
                          <v-list-item-content>
                            <v-list-item-title style="font-size:13px;font-weight:600;">{{ p.staffcode }}</v-list-item-title>
                            <v-list-item-subtitle style="font-size:11px;">{{ p.compnyname }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-icon v-if="p.id == activeStaffId" style="margin:auto 0;">
                            <v-icon small color="#4F6BFF">mdi-check</v-icon>
                          </v-list-item-icon>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-btn icon @click="backHome()" title="Home" style="color:#4F6BFF;">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9.5z"/>
                        <polyline points="9 21 9 12 15 12 15 21"/>
                      </svg>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card>
            <v-card>
              <v-row class="ml-4 pb-4 mr-4 pt-2">
               <app-menu-selfservice />
              </v-row>
            </v-card>
          </div>
        </div>
        <!-- End vertical navbar -->

        <!-- Page content holder -->
        <div class="page-content px-5" id="content" :style="{ marginTop: '72px', paddingBottom: isAiAllowed ? '100px' : '0' }">
  <div
    style="position: relative; width: 100%; display: flex; align-items: center; gap: 1rem;"
  >
    <!-- Profile Button -->
    <v-btn
      v-if="adminMenuAvailable && !this.$route.name.includes('selfservice')"
      id="sidebarCollapse"
      type="button"
      class="btn btn-light bg-white rounded-pill shadow-sm px-4 mt-2"
      @click="toggleClass()"
    >
      <v-icon small class="mr-2">mdi-menu</v-icon>
      <small class="text-uppercase font-weight-bold">{{$t('Menu')}}</small>
    </v-btn>

    <v-btn
      v-else
      id="sidebarCollapse"
      type="button"
      class="btn btn-light bg-white rounded-pill shadow-sm px-4 mt-2"
      @click="toggleClass()"
    >
      <v-icon small class="mr-2">mdi-account</v-icon>
      <small class="text-uppercase font-weight-bold">{{$t('settingsswitchprofilemobile.profile')}}</small>
    </v-btn>

    <!-- KPI and Review Buttons -->
    <!-- <div
      v-if="['selfservice/performance', 'selfservice/review', 'selfservice/kpi'].some(name => $route.name.includes(name))" style="display: flex; gap: 0.5rem; align-items: center; margin-top: 10px;"
    > -->
    <div v-if="this.$route.name.includes('selfservice') && !this.$route.name.includes('attendance') && (this.$route.name.includes('performance') || this.$route.name.includes('review') || this.$route.name.includes('kpi') || this.$route.name.includes('mystaff'))"
      style="display: flex; gap: 0.5rem; align-items: center; margin-top: 10px;">
      <button class="btn shadow-sm px-4" :style="($route.path.includes('/kpi') || $route.path.includes('/performance')) ? 'background-color: #1261a0; color: white;' : 'background-color: #f8f9fa; color: black;'" @click="goToPage('kpi')">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle;margin-right:6px;"><path d="M12 20V10"/><path d="M18 20V4"/><path d="M6 20v-6"/></svg>
        KPI
      </button>
      <button class="btn shadow-sm px-4" :style="($route.path.includes('/review')) ? 'background-color: #1261a0; color: white;' : 'background-color: #f8f9fa; color: black;'" @click="goToPage('review')">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle;margin-right:6px;"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
        Review
      </button>
      <button v-if="isOwnerStaff" class="btn shadow-sm px-4" :style="($route.path.includes('/mystaff')) ? 'background-color: #1261a0; color: white;' : 'background-color: #f8f9fa; color: black;'" @click="goToPage('mystaff')">
        <v-icon small class="mr-2" :style="($route.path.includes('/mystaff')) ? 'color: white;' : 'color: black;'">mdi-account-group</v-icon>
        My Staff
      </button>
    </div>

    <!-- Attendance Tabs -->
    <div v-if="this.$route.name.includes('selfservice') && this.$route.name.includes('attendance')"
      style="display: flex; gap: 0.5rem; align-items: center; margin-top: 10px;">
      <button class="btn shadow-sm px-4" :style="!$route.path.includes('/attendance/mystaff') ? 'background-color: #1261a0; color: white;' : 'background-color: #f8f9fa; color: black;'" @click="goToAttendancePage('myschedule')">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle;margin-right:6px;"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
        My Schedule
      </button>
      <button v-if="isOwnerStaff" class="btn shadow-sm px-4" :style="$route.path.includes('/attendance/mystaff') ? 'background-color: #1261a0; color: white;' : 'background-color: #f8f9fa; color: black;'" @click="goToAttendancePage('mystaff')">
        <v-icon small class="mr-2" :style="$route.path.includes('/attendance/mystaff') ? 'color: white;' : 'color: black;'">mdi-account-group</v-icon>
        My Staff
      </button>
    </div>
  </div>

  <div style="position:relative;background:#ffffff;border-radius:14px;border:1px solid #E8EDF5;box-shadow:0 2px 12px rgba(79,107,255,0.07);overflow:visible;margin-top:8px;min-height:calc(100vh - 150px);display:flex;flex-direction:column;">
    <div style="background:linear-gradient(135deg,#4F6BFF 0%,#7C3AFF 100%);height:4px;border-radius:14px 14px 0 0;"></div>
    <router-view style="flex:1;display:flex;flex-direction:column;" />
  </div>
</div>


      </v-layout>
    </v-container>

    <div v-if="isAiAllowed">
      <tara-floating-assistant />
    </div>
  </v-content>

</template>

<script>
import Menu from "./components/common/Menu";
import MenuSelfService from "./components/common/MenuSelfService";
import TaraFloatingAssistant from "./components/ai/TaraFloatingAssistant.vue";

// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";
// import "jquery/dist/jquery.slim.min.js";
// import "popper.js/dist/umd/popper.min.js";
import "jquery/dist/jquery.min.js";
import $ from "jquery";
export default {
  components: {
    "app-menu": Menu,
    "app-menu-selfservice": MenuSelfService,
    "tara-floating-assistant": TaraFloatingAssistant,
  },

  computed: {
    activeProfile() {
      return this.staffProfiles.find(p => p.id == this.activeStaffId) || null;
    },
  },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      showMenuOverview: true,
      adminMenuAvailable: null,
      personName: null,
      personPic: null,
      isOwnerStaff: false,
      isAiAllowed: false,
      sidebarOpen: false,
      staffProfiles: [],
      activeStaffId: null,
    };
  },

  // watch : {
  //   currentPath() {
  //     console.log(this.$route);
  //   }
  // },

  methods: {
    toggleClass() {
      this.sidebarOpen = !this.sidebarOpen;
      $("#sidebar, #content").toggleClass("active");
    },

    goToPage(performancetype) {
      if(performancetype == 'kpi') {
        this.$router.push({ name: "selfserviceperformance" });
      } else if (performancetype == 'review') {
        this.$router.push({ name: "selfservicereview"});
      } else {
        this.$router.push({ name: "selfservicemystaff"});
      }
      // this.$router.push({ name: "selfserviceperformance", params: {performancetype: performancetype} });
    },
    
    goToAttendancePage(tab) {
      if (tab === 'myschedule') {
        this.$router.push({ name: 'selfserviceattendance' });
      } else {
        this.$router.push({ name: 'selfserviceattendancemystaff' });
      }
    },

    backHome() {
      this.$router.push({name: 'selfservicehome'});
    },

    loadStaffProfiles() {
      const psnId = this.$store.getters.psnId;
      if (!psnId) return;
      this.$store.dispatch('get', { url: `/ss/staff/profiles/${psnId}` })
        .then(res => {
          if (res.data.status === 200) {
            this.staffProfiles = res.data.rec;
            this.activeStaffId = this.$store.getters.staffId;
          }
        })
        .catch(() => {});
    },

    switchProfile(staffId) {
      this.$store.commit('switchStaff', staffId);
      this.activeStaffId = staffId;
      this.isOwnerStaff = false;
      this.$store.dispatch("get", { url: `/roleassignment/isowner/${staffId}` })
        .then((res) => { this.isOwnerStaff = res.data.isOwner === true; })
        .catch(() => { this.isOwnerStaff = false; });
      if (this.$route.name !== 'selfservicehome') {
        this.$router.push({ name: 'selfservicehome' });
      }
    },
  },

  mounted() {

    // Check if admint or not
    this.adminMenuAvailable = this.$store.getters.userType == 1 ? true : false;
    // console.log("Admin ?", this.adminMenuAvailable);
    // console.log("Current Route Name:", this.$route.name);
    // console.log("Includes 'selfservice'?", this.$route.name.includes('selfservice'));

    // Assign Person Name
    this.personName = this.$store.getters.personName;

    // Assign Person Pic
    this.personPic = this.$store.getters.personPic;

    // Load all staff profiles for this person (for profile switching)
    this.loadStaffProfiles();

    // Check if logged-in staff is an owner in roleassign
    const staffId = this.$store.getters.staffId;
    if (staffId) {
      this.$store.dispatch("get", { url: `/roleassignment/isowner/${staffId}` })
        .then((res) => { this.isOwnerStaff = res.data.isOwner === true; })
        .catch(() => { this.isOwnerStaff = false; });
    }

    var sessions = "";
    sessions = JSON.parse(this.$store._vm.$session.get("access_token"))
    const funcaccess = sessions.funcaccess || [];
    const hrChat = funcaccess.find(e => e.funcname === "HR Chat" && e.canaccess === "Y");
    const lic = sessions.licenseAccess;
    const licOk = lic === true || (Array.isArray(lic) && lic.includes(hrChat?.funccatid));
    this.isAiAllowed = !!hrChat && licOk;

    // console.log("what is my lic", lic);
    // console.log("is allowed", this.isAiAllowed);


    //toggle sidebar
    // $("#sidebarCollapse").on("click", function () {
    //   $("#sidebar, #content").toggleClass("active");
    // });

  },
};
</script>

<style scoped>
.sidebar-backdrop {
  display: none;
}

.sidebar-close-btn {
  display: none;
}

@media (max-width: 768px) {
  .sidebar-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 1000;
  }

  .sidebar-close-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    color: #64748B;
    padding: 4px;
    border-radius: 6px;
    flex-shrink: 0;

    &:hover {
      background: #F1F5F9;
      color: #1E293B;
    }
  }
}
</style>